import React from "react";
// import { Link } from "react-router-dom";

// import icon1 from "../assets/images/icons/color-swatches.svg";
// import icon2 from "../assets/images/icons/decent-work-and-economic-growth.svg";
// import icon3 from "../assets/images/icons/flip-horizontal-arrow-1.svg";
// import icon4 from "../assets/images/icons/layers-1.svg";
// import icon5 from "../assets/images/icons/pictures-folder-memories.svg";
// import logo1 from "../assets/images/icons/bottom.svg";
// import logo2 from "../assets/images/sidom/svg/aduana.svg";
import nube from "../assets/images/sidom/svg/nube-dark.svg";
import nube2 from "../assets/images/sidom/svg/nube-light.svg";

// import CarouselText from "./CarouselText";
// import { FiHexagon } from "../assets/icons/vander";

export default function Features() {
  // const featuresData = [
  //   {
  //     image: icon1,
  //     title: "Grow Your Business",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  //   {
  //     image: icon2,
  //     title: "Drive More Sales",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  //   {
  //     image: icon3,
  //     title: "Handled By Expert",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  //   {
  //     image: icon4,
  //     title: "Discussion For Idea",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  //   {
  //     image: icon5,
  //     title: "Increase Conversion",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  //   {
  //     image: icon6,
  //     title: "Sales Growth Idea",
  //     desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  //   },
  // ];
  return (
    <div className=" mt-[100px]   border border-sidom-light dark:border-sidom-blue">
      <div className="  border border-sidom-light dark:border-sidom-blue  text-sidom-light dark:text-sidom-light">
        <div className="flex  flex-col gap-2   mt-[100px] mb-[100px]   text-center">
          <div className="flex flex-col md:flex-row mb-3 justify-center  items-center gap-2">
            <img
              src="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/sidom.svg"
              className="h-8"
              alt="Logo Sidom"
            />
            <h3 className="text-3xl font-bold text-sidom-dark  dark:text-sidom-light">
              Global Trade
            </h3>
          </div>

          <p className="text-2xl md:text-3xl lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-dark  dark:text-sidom-light mb-3">
            El poder de la integración 4PL
          </p>

          <p className="text-lg text-sidom-dark    dark:text-sidom-light max-w-xl mx-auto">
            La única plataforma 100% Web/SaaS para la gestión punta a punta de
            la operatoria de importadores y exportadores.
          </p>

          <div className="w-full flex justify-center p-6 md:p-1 lg:p-0 items-center  mt-[60px] ">
            <img
              src={nube}
              className="hidden dark:block w-[800px]"
              alt="Imagen modo oscuro"
            />
            <img
              src={nube2}
              className="block dark:hidden w-[800px]"
              alt="Imagen modo claro"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col mb-[40px] mt-[100px]  items-center w-full text-sidom-dark dark:text-sidom-light">
        <div className="w-full aspect-video max-h-[900px] ">
          <video
            controls
            autoPlay
            muted
            loop
            className="w-full h-full object-cover aspect-video shadow-md"
          >
            <source
              src="https://api.institucional.global.sidom.io/uploads/presentacion_gt_mej_7c5618d96b.mp4"
              type="video/webm"
            />
          </video>
        </div>
        <div className="w-full container    leading-[1.3]  text-left">
          <h2 className="text-sidom-orange text-4xl md:text-5xl mt-[60px] font-extrabold">
            ¿Cómo logramos esto?
          </h2>
        </div>

        <div className="w-full container   mt-[60px] leading-[1.3] flex justify-center">
          <div className=" text-left   text-base md:text-lg leading-relaxed space-y-6 first-line:">
            <p>
              Mediante la implementación de tecnologías de Automatización
              Robótica de Procesos (RPA) e Inteligencia Artificial,{" "}
              <strong>SIDOM</strong> ha eliminado las barreras que obstaculizan
              el comercio internacional, optimizando la eficiencia y reduciendo
              los costos operativos.
            </p>
            <p>
              En <strong>SIDOM</strong>, tenemos la misión de convertirnos en un
              socio tecnológico global llevando los negocios internacionales de
              nuestros clientes a un nivel superior.
            </p>
            <p>
              Desde <strong>SIDOM GT</strong> buscamos construir un mundo en el
              que los negocios fluyan sin obstáculos, donde las transacciones
              sean seguras, rápidas y eficientes, ya que creemos firmemente que
              el futuro del comercio exterior es la tecnología aplicada para
              hacer Simple lo Complejo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
